<template>
  <div class="account-number-select" ref="accountNumber">
    <el-select style="width:100%;"
               v-model="value"
               @change="change"
               value-key="tradeAccountNumber"
               :placeholder="$t('deposit.upload.please_sel')">
      <el-option v-for="(item,key) in getFilterAccountInfo"
                 :disabled="item.disabled"
                 :key="key"
                 :label="`${$t('tradeAccountType.'+item.tradeAccountType)} | ${item.tradeAccountNumber}`"
                 :value="item"></el-option>
    </el-select>
    <!-- <bDialog :dialogVisible.sync="dialogVisible" :component="component" :contiune="contiune" :showClose="showClose"></bDialog> -->
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import BScroll from 'better-scroll'
// import _ from 'lodash'
export default {
  data () {
    return {
      value: '', // TODO 获取存储的全局交易账号,
      accountNumbers: this.$store.getters.accountNumbers
    }
  },
  computed: {
    ...mapGetters(['getUser', 'getFilterAccountInfo']),
    ...mapState(['accountInfo']),
    tradeAccountList () {
      return this.accountInfo
    }
  },
  async mounted () {
    // TODO 获取当前账号下是否有交易账号列表
    let accountNumbers = this.accountNumbers
    if (accountNumbers.length === 0) {
      // TODO 发送请求
      // const profile = this.$getProfile()
      // const accountNumber = profile.custom.accountNumber
      // const result = await this.$api.getAcountType({
      //   accountNumber: accountNumber
      // })
      let arr = this.tradeAccountList
      let tempaccountNumbers = []
      for (let i = 0; i < arr.length; i++) {
        let tradeAccountType = arr[i].tradeAccountType.toLowerCase().replace(/_[a-z]/g, function (m) {
          return m.slice(1).toUpperCase()
        })
        let tradeAccountTypeConfig = this.tradeAccountConfig(tradeAccountType) && this.tradeAccountConfig(tradeAccountType)['tradeAccountType']
        let item = {}
        item.type = arr[i].type
        item.label = this.$t(`tradeAccountType.${tradeAccountTypeConfig}`)
        item.value = arr[i].tradeAccount
        item.accountType = arr[i].accountType
        item.disabled = false
        item.tradeAccountType = tradeAccountType
        tempaccountNumbers.push(item)
      }
      this.$store.commit('setAccountNumbers', tempaccountNumbers)
      this.$store.commit('setValueAccountNumber', tempaccountNumbers[0].value)
      localStorage.setItem('tradeAccount', tempaccountNumbers[0].value)
      this.accountNumbers = tempaccountNumbers
    }
  },
  methods: {
    // getKey (key) {
    //   let item = this.$t('common')
    //   return item[key] ? item[key] : key
    // },
    tradeAccountConfig (tradeAccountType) {
      return this.Util.getTradeAccountConfig(tradeAccountType)
    },
    getTypeKey (arr, key) {
      let item = this.$t(arr)
      return item[key] ? item[key] : key
    },
    getTradeAccountBalance (val, type) {
      this.$api
        .getTradeAccountBalance(val, {
          accountId: this.$getProfile().custom.accountId,
          tradeAccount: val,
          type
        })
        .then(result => {
          this.$emit('accountInfo', result)
          this.$nextTick(() => {
            this.scroll = new BScroll(this.$refs.accountNumber, {})
          })
        })
    },
    change (val) {
      // const index = _.findIndex(this.accountNumbers, function (o) {
      //   return o.value === val
      // })

      // let tradeAccountObj = this.accountNumbers[index]
      // this.getTradeAccountBalance(val, tradeAccountObj.type)
      this.$store.commit('setValueAccountNumber', val.tradeAccountNumber)
      this.$emit('change', val)
    },
    selectIndex (n) {
      let item = this.accountNumbers[n]
      this.value = item.value
      console.log(item)
    }
  },
  watch: {

  }
}
</script>

<style scoped>
</style>
